import { ReportHubDto } from "@flexidao/dto";
import SmartAssignmentStrategy = ReportHubDto.SmartAssignmentStrategy;

export const formatSmartAssignmentStrategy = (strategy: SmartAssignmentStrategy): string => {
    switch (strategy) {
        case SmartAssignmentStrategy.NonSingleMarketOnly:
            return "Assign tracking instruments from non-single-market countries to their country of origin";
    }
};
